import React, {useEffect} from 'react';
import Box from '@material-ui/core/Box';
import HomeHeaderSection from './components/HomeHeaderSection';
import FAQSection from './components/FAQSection';
import overviewActions from '../../actions/overview.actions';
import {getLocale} from 'epic-common/src/locale';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../..';
import {isActiveAffiliate} from '../../utils/ValidationUtils';
import {Footer, Header, WarningBars} from '../../components';
import {
    selectAccountInfo,
    selectAffiliate,
    selectConfig,
    selectMessages,
    selectOverview,
    selectTax
} from '../../selectors';

//@ts-ignore
import styles from './Overview.pcss';

const Overview = () => {
    const dispatch = useDispatch();
    const overviewState = useSelector(selectOverview);
    const messages = useSelector(selectMessages);
    const configState = useSelector<RootState, any>(selectConfig);
    const affiliateAccount = useSelector(selectAffiliate);
    const accountInfo = useSelector(selectAccountInfo);
    const taxState = useSelector(
        state => accountInfo && accountInfo.isLoggedIn && selectTax(state)
    );

    useEffect(() => {
        dispatch(
            overviewActions.getHome({
                locale: getLocale()
            })
        );
    }, []);

    const {enableV2Signup, enableReactivation} = configState;
    const {v2BackgroundImage, faq} = overviewState || {};
    const style = {backgroundImage: null};

    if (v2BackgroundImage) {
        style.backgroundImage = `url("${v2BackgroundImage}")`;
    }

    const isLoggedIn = accountInfo && accountInfo.isLoggedIn;
    const {taxCountrySanctioned, taxInterviewUrl: isTakingTaxInterview} = taxState || {};
    const {canEditSettings} = affiliateAccount || {};
    const showWarningBars = !isTakingTaxInterview;

    return (
        <>
            <div id="imgOverlay" className={styles.container} style={style}>
                <Header
                    className={styles.header}
                    messages={messages}
                    affiliateAccount={affiliateAccount}
                    accountInfo={accountInfo}
                    configState={configState}
                    taxState={taxState}
                />

                {showWarningBars && (
                    <Box sx={{width: '90%', margin: '0 auto'}}>
                        <WarningBars
                            key="alert"
                            messages={messages}
                            canViewAlerts={
                                isLoggedIn &&
                                !taxCountrySanctioned &&
                                (isActiveAffiliate(affiliateAccount) || canEditSettings)
                            }
                        />
                    </Box>
                )}

                <HomeHeaderSection
                    messages={messages}
                    overviewState={overviewState}
                    affiliateAccount={affiliateAccount}
                    enableV2Signup={enableV2Signup}
                    enableReactivation={enableReactivation}
                    isLoggedIn={accountInfo.isLoggedIn}
                />
            </div>

            <FAQSection {...faq} />

            <Footer content={configState.epicFooter} accountInfo={accountInfo} />
        </>
    );
};

export default Overview;
